import { Component } from '@angular/core';
import { ContentComponent } from '../../content/content.component';
import { OneColumnComponent } from '../../../shared/layout/one-column/one-column.component';
import { EventsHomeComponent } from '../events/events-home.component';

@Component({
  template: `
    <lib-one-column>
      <div class="flex gap-2 pb-3" style="min-height: 425px">
        <div class="content-wrapper flex-1 left-page">
          <app-content name="aboutUsHome"></app-content>
        </div>
        <div class="content-wrapper flex-1 right-page">
          <app-content name="howItWorksHome"></app-content>
        </div>
      </div>
      <app-events-home></app-events-home>
    </lib-one-column>
  `,
  styles: [
    `
      .left-page {
        background-color: whitesmoke;
        font-size: larger;
        padding: 32px;
      }

      .right-page {
        background-color: #4b7b2b;
        color: #fff;
        font-size: larger;
        padding: 32px;
      }
    `,
  ],
  standalone: true,
  imports: [ContentComponent, OneColumnComponent, EventsHomeComponent],
})
export class HomeComponent {
  constructor() {}
}
